<template>
    <div class="dashboard-layout">
        <header class="header">
            <h1 @click="router.push('/')">Dashboard</h1>
            <CButton class="border" @click="logout">Déconnexion</CButton>
        </header>

        <section class="sidebar">
            <nav class="nav">
                <router-link to="/organizations">
                    <img src="@ezio/assets/images/main-nav/organisation-on.svg" class="on" />
                    <img src="@ezio/assets/images/main-nav/organisation-off.svg" class="off" />
                    <span>Organisations</span>
                </router-link>

                <router-link to="/agencies">
                    <img src="@ezio/assets/images/main-nav/home-on.svg" class="on" />
                    <img src="@ezio/assets/images/main-nav/home-off.svg" class="off" />
                    <span>Établissements</span>
                </router-link>

                <router-link to="/networks">
                    <img src="@ezio/assets/images/main-nav/network-on.svg" class="on" />
                    <img src="@ezio/assets/images/main-nav/network-off.svg" class="off" />
                    <span>Réseaux</span>
                </router-link>
                <router-link to="/bank">
                    <img src="@ezio/assets/images/main-nav/bank-on.svg" class="on" />
                    <img src="@ezio/assets/images/main-nav/bank-off.svg" class="off" />
                    <span>Bancaire</span>
                </router-link>
            </nav>
            <div class="logo">
                <img src="@ezio/assets/images/ezio/Logo-EZIO.png" alt="" />
            </div>
        </section>

        <router-view />
    </div>
</template>

<script lang="ts" setup>
import { reset } from '@/stores'
import { useRouter } from 'vue-router'

const router = useRouter()

const logout = () => {
    reset()
    router.replace('/sign-in')
}
</script>
<style lang="scss" scoped>
.dashboard-layout {
    display: grid;
    grid-template-columns: 130px 1fr;
    grid-template-rows: auto 1fr;

    width: 100%;
    height: 100vh;
    @media screen and (max-width: 799px) {
        grid-template-rows: auto auto 1fr;
        grid-template-columns: 1fr;
    }
}

.header {
    grid-column: 1 / -1;
    position: relative;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 50px;
    background: #fff;
    border-bottom: 1px solid var(--c-color-border-hard);

    @media screen and (max-width: 799px) {
        padding: 10px 20px;
    }

    h1 {
        color: var(--c-color-primary);
        font-weight: 400;
        font-size: 1.2rem;
    }
}

.sidebar {
    position: relative;
    z-index: 2;
    background: #fff;
    box-shadow: 0px 0px 10px #ccc;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .logo {
        img {
            display: block;
            width: 100%;
            padding: 8px;
        }
        @media screen and (max-width: 799px) {
            display: none;
        }
    }
}

.nav {
    a {
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 23px 50px 20px;
        border-bottom: 1px solid var(--c-color-border-hard);
        border-right: 0px solid var(--c-color-primary);
        color: var(--c-color-primary);
        font-size: 0.8rem;
        text-decoration: none;
        transition: all 0.2s;

        img {
            width: 34px;
            margin-bottom: 6px;
        }

        .on {
            display: none;
        }

        &.router-link-active,
        &:hover {
            color: var(--c-color-alert);
            background: #fff;
            border-right-width: 6px;

            .on {
                display: block;
            }
            .off {
                display: none;
            }
        }
    }
    @media screen and (max-width: 930px) {
        display: flex;
        justify-content: space-evenly;
        padding: 0 20px;

        a {
            padding: 10px 10px 2px;
            border-right: 0;
            border-bottom: 0px solid var(--c-color-primary);

            &.router-link-active,
            &:hover {
                color: var(--c-color-text-hard);
                background: #fff;
                border-bottom-width: 2px;
                border-right-width: 1px;
            }
            span {
                display: none;
            }
        }
    }
}
</style>
